<template>
  <div>

    <table v-if="isScoreHistoryTableVisible" class="table score-table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col" class="min-width">№</th>
          <th scope="col" class="min-width text-right">Time from start</th>
          <th scope="col" class="min-width text-right">Score</th>
        </tr>
      </thead>
      <tr
        v-for="(record, index) in scoreHistory"
        :key="index"
      >
        <td class="text-right">
          {{index + 1 | getFormattedNumber}}
        </td>
        <td class="text-right">
          {{record.ctime | convertDurationSecToShortStr}}
        </td>
        <td class="text-right">
          {{record.score | getFormattedNumber}}
        </td>
      </tr>
      <tr v-if="isScoreSumVisible">
        <td colspan="3" class="text-right pt-4">
          Sum: {{scoreSum | getFormattedNumber}}
        </td>
      </tr>
    </table>

    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>
  </div>
</template>

<script>
import { HTTP } from '../http-common.js';

import { convertDurationSecToShortStr } from '../util.js';

import notifier from '../notifier.js';

import LoadingIndicator from './LoadingIndicator.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'ContestPlayerScoreHistory',

  components: {
    LoadingIndicator,
  },

  props: {
    contestPlayerId: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,
      scoreHistory: null,
    };
  },

  computed: {
    /** @returns {number} */
    contestId() {
      return this.contestPlayerId.contestId;
    },

    /** @returns {number} */
    playerId() {
      return this.contestPlayerId.playerId;
    },

    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(!this.isLoadedNormal) {
        return null;
      }

      const NO_ITEMS_TEXT = 'No records.';
      const scoreHistory = this.scoreHistory;
      if(scoreHistory === null) {
        return NO_ITEMS_TEXT;
      }
      if(scoreHistory.length === 0) {
        return NO_ITEMS_TEXT;
      }

      return null;
    },

    /** @returns {boolean} */
    isScoreHistoryTableVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      const scoreHistory = this.scoreHistory;
      if(scoreHistory === null) {
        return false;
      }

      return scoreHistory.length > 0;
    },

    /** @returns {boolean} */
    isScoreSumVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      const scoreHistory = this.scoreHistory;
      if(scoreHistory === null) {
        return false;
      }

      return scoreHistory.length > 1;
    },

    /** @returns {?number} */
    scoreSum() {
      if(!this.isLoadedNormal) {
        return null;
      }

      const scoreHistory = this.scoreHistory;
      if(scoreHistory === null) {
        return 0;
      }

      let sum = 0;
      for(const item of scoreHistory) {
        sum += item.score;
      }

      return sum;
    },
  },

  created() {
    this.loadScoreHistory();
  },

  methods: {
    loadScoreHistory() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const contestId = this.contestId;
      const playerId = this.playerId;
      const url = `/contest/${contestId}/player/${playerId}/score_history`;

      HTTP.get(url)
      .then(response => {
        this.scoreHistory = response.data.data;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },

  filters: {
    convertDurationSecToShortStr,
  },
};
</script>


<style scoped>
.score-table {
  max-width: 1px;
}
</style>
